// Libs
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { useTheme } from '@material-ui/core/styles';

// Actions
import { nextCheck } from 'REDUCERS/navSlice';

// Components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Support from 'COMPONENTS/Support';

// Utils
import useTranslator from 'UTILS/hooks/useTranslator';
import { BROWSER_CHECK, NARROW_LAYOUT } from 'UTILS/constants';
import { onTrackedClick } from 'UTILS/callbacks';
import { CHECK_RESULT_MAP } from 'CHECKS/index';
import translations from './locales.json';

const { title, hintList } = CHECK_RESULT_MAP['permissions_help'];

const PermissionsInfo = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const [translate] = useTranslator(translations);
  const boxStyles = {
    display: isSmallScreen ? 'block' : 'flex',
    flexDirection: isSmallScreen ? null : 'column',
    alignItems: isSmallScreen ? null : 'center',
  };
  const whiteBackground = theme.palette.background.paper;

  const handleSupportClose = () => {
    onTrackedClick(`close_support`, 'permission_info');
    setIsSupportOpen(false);
  };

  const handleSupportOpen = () => {
    onTrackedClick(`open_support`, 'permission_info');
    setIsSupportOpen(true);
  };

  const handleGetItClick = () => {
    onTrackedClick(`start`, 'permission_info');
    dispatch(nextCheck());
  };

  const containerClasses = cx('permissionsInfo-container', {
    'permissionsInfo-container_largerScreen': !isSmallScreen,
  });

  return (
    <Box className={containerClasses} bgcolor={isSmallScreen ? whiteBackground : null} >
      <Box bgcolor={!isSmallScreen ? whiteBackground : null} className='permissionsInfo-surface' >
        {isSmallScreen && (
          <img src={theme.assets.appLogo} alt='logo acetiam' className='permissionsInfo-smallLogo' />
        )}
        <Typography align='center' variant='h5'>
          <Box component='span' fontWeight='bold' >
            {translate('cameraAndMicrophone')}
          </Box>
        </Typography>
        <Box>
          <img src={theme.assets.cameraLogo} alt='logo custom' className='permissionsInfo-bigLogo' />
          <img src={theme.assets.microphoneLogo} alt='logo custom' className='permissionsInfo-bigLogo' />
        </Box>
        <Container maxWidth={isSmallScreen ? 'md' : 'sm'} >
          <Box {...boxStyles} >
            <Box className={!isSmallScreen ? 'permissionsInfo-adviceMessage_marginLargeScreen' : null}>
              <Typography variant='body2' paragraph color='textSecondary' className='permissionsInfo-adviceMessage'>
                {translate('toBeginTestingYourHardwareYouNeedToAllowYourBrowserToAccessYourCameraAndMicrophone')}
              </Typography>
            </Box>
            <Box className='permissionsInfo-rememberChoiceMessage' style={{ borderColor: theme.palette.grey[400] }}>
              <Box display='flex'>
                <InfoOutlinedIcon className='permissionsInfo-infoIcon' />
                <Typography variant='body2' color='textSecondary' >{translate('toKeepYourChoiceAndOnlyPerformTheActionOnceCheckTheBoxRememberMyChoice')}</Typography>
              </Box>
              <Button variant='text' onClick={handleSupportOpen}>{translate('help')}</Button>
            </Box>
            <Box className={!isSmallScreen ? 'permissionsInfo-validationButton_largeScreen' : null} >
              <Button variant='contained' size='large' color='primary' fullWidth onClick={handleGetItClick}>
                {translate('iGetIt')}
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
      <Support
        open={isSupportOpen}
        onClose={handleSupportClose}
        title={title}
        hintList={hintList}
        checkLabel={BROWSER_CHECK}
      />
    </Box>
  );
};

export default PermissionsInfo;
